import { FC } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/Dialog/Dialog'
import { AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { useTranslation } from 'react-i18next'
import { CreateClientForm } from '@/features/Client/CreateClientForm/ui/CreateClientForm'

type CreateClientModalProps = {
  dialogProps: AlertDialogProps
  onCloseModal: () => void
}

export const CreateClientModal: FC<CreateClientModalProps> = props => {
  const { dialogProps, onCloseModal } = props
  const { t } = useTranslation(['client'])
  return (
    <Dialog {...dialogProps}>
      <DialogContent className={'overflow-y-auto max-h-[95vh]'}>
        <DialogHeader>
          <DialogTitle>{t('client:create_client_modal_title')}</DialogTitle>
          <CreateClientForm onCloseModal={onCloseModal} />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
